"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatabasesBreadcrumbsUpdater = exports.DatabaseBreadcrumbsUpdater = void 0;
const tslib_1 = require("tslib");
const catalog_core_1 = require("@tableau/catalog-core");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const reselect_1 = require("reselect");
const BreadcrumbFactories_1 = require("./BreadcrumbFactories");
const BreadcrumbsUpdater_1 = require("./BreadcrumbsUpdater");
function createDatabaseBreadcrumbsList(databaseId, databaseName, urls, urlSuffix) {
    return [
        (0, BreadcrumbFactories_1.createCatalogBreadcrumb)(urls),
        (0, BreadcrumbFactories_1.createCatalogDatabaseBreadcrumb)(databaseId, databaseName, urls, urlSuffix),
    ];
}
class DatabaseBreadcrumbsUpdater extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.memoizedCreateDatabaseBreadcrumbsList = (0, reselect_1.defaultMemoize)(createDatabaseBreadcrumbsList);
    }
    render() {
        if (this.props.databaseName === null) {
            return null;
        }
        return (react_1.default.createElement(catalog_core_1.SiteUrlsContext.Consumer, null, urls => (react_1.default.createElement(react_router_dom_1.Route, null, ({ location }) => {
            const breadcrumbs = this.memoizedCreateDatabaseBreadcrumbsList(this.props.databaseId, this.props.databaseName || '', urls, location.search);
            return react_1.default.createElement(BreadcrumbsUpdater_1.BreadcrumbsUpdater, { breadcrumbs: breadcrumbs });
        }))));
    }
}
exports.DatabaseBreadcrumbsUpdater = DatabaseBreadcrumbsUpdater;
function createDatabasesBreadcrumbsList(urls, urlSuffix) {
    return [
        (0, BreadcrumbFactories_1.createCatalogDatabasesBreadcrumb)(urls, urlSuffix),
    ];
}
class DatabasesBreadcrumbsUpdater extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.memoizedCreateDatabasesBreadcrumbsList = (0, reselect_1.defaultMemoize)(createDatabasesBreadcrumbsList);
    }
    render() {
        return (react_1.default.createElement(catalog_core_1.SiteUrlsContext.Consumer, null, urls => (react_1.default.createElement(react_router_dom_1.Route, null, ({ location }) => {
            const breadcrumbs = this.memoizedCreateDatabasesBreadcrumbsList(urls, location.search);
            return react_1.default.createElement(BreadcrumbsUpdater_1.BreadcrumbsUpdater, { breadcrumbs: breadcrumbs });
        }))));
    }
}
exports.DatabasesBreadcrumbsUpdater = DatabasesBreadcrumbsUpdater;
//# sourceMappingURL=DatabaseBreadcrumbsUpdater.js.map